<template>
    <div class="inline-block">
        <a href="javascript:void()" @click.prevent="open = true">{{ taxRateReadable }}</a>
        <div class="modal" v-if="open">
            <div class="modal-container">
                <div class="modal-header">
                    <close-icon v-on:click="closeView"></close-icon>
                    <h1>Account Tax Rate</h1>
                </div>

                <div class="modal-body">
                    <div>
                        <p>This tax rate will be the default rate applied to all transactions by this Account.</p>

                        <p class="font-bold">The only scenarios where this should normally be changed are where the customer is a business based outside of the UK.</p>

                        <div class="form-field">
                            <label>Tax Rate</label>
                            <div class="flex items-center justify-start max-w-xs">
                                <TaxRateSelect v-model="value"/>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <div class="flex">
                        <div class="left text-left">

                        </div>

                        <div class="middle text-middle">

                        </div>

                        <div class="right text-right">
                            <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                            <button class="btn-primary" type="button" @click="save">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TaxRateSelect from '../../TaxRateSelect'

    export default {
        name: 'TaxRate',
        components: {TaxRateSelect},
        props: {
            account: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                open: false,
                value: null,
            }
        },
        computed: {
            taxRateReadable() {
                return (this.account.tax_rate.tax_rate * 100).toFixed(2) + '%'
            },

            isDefault() {
                return this.account.is_default ?? false
            },
        },
        methods: {
            closeView() {
                this.open = false
            },

            save() {
                axios.put(route('accounts.taxrate', this.account.id), {
                    tax_rate: this.value.rate,
                })
                    .then(response => {
                        this.$emit('updated')
                        this.$bus.$emit('alert.success', 'Tax rate for the account has been updated.')
                        this.closeView()
                    })
                    .catch(e => {
                        console.error({e})
                    })
            },
        },
        watch: {
            open(newValue) {
                if (newValue) {
                    this.value = this.$store.state.taxRates.find(el => el.rate === this.account.tax_rate.tax_rate)
                }
            },
        }
    }
</script>
